export const actionCategory: any = {
  "Threat": "Threat",
  "Clean": "Clean",
  "Unknown": "Unknown"
}

export const statusDropdown: any = {
  "Received": {bg: "#EDEDED", hover: "#EDEDED"},
  "In Review": {bg: "#E1EFEF", hover: "#E1EFEF"},
  "Resolved": {bg: "#f2fad9", hover: "#f2fad9"},
}

export const priorityDropdown: any = {
  "High": {bg: "#ED1C24", hover: "#B20007"},
  "Medium": {bg: "#FCAB10", hover: "#D88E00"},
  "Low": {bg: "#03A9F5", hover: "#007AB2"},
  "Unknown": {bg: "#909090", hover: "#707070"}
}
